import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUserEmailDetails = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.GET_USER_EMAIL_DETAILS
  );
};

export default getUserEmailDetails;
